var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.75C6.19063 4.75 4.71875 6.22188 4.71875 8.03125C4.71875 9.84063 6.19063 11.3125 8 11.3125C9.80938 11.3125 11.2813 9.84063 11.2813 8.03125C11.2813 6.22188 9.80938 4.75 8 4.75ZM8 4.75C6.19063 4.75 4.71875 6.22188 4.71875 8.03125C4.71875 9.84063 6.19063 11.3125 8 11.3125C9.80938 11.3125 11.2813 9.84063 11.2813 8.03125C11.2813 6.22188 9.80938 4.75 8 4.75ZM13.6563 0H2.34375C1.05 0 0 1.05 0 2.34375V13.6563C0 14.95 1.05 16 2.34375 16H13.6563C14.95 16 16 14.95 16 13.6563V2.34375C16 1.05 14.95 0 13.6563 0ZM8 12.25C5.67503 12.25 3.78125 10.3562 3.78125 8.03125C3.78125 5.70622 5.67503 3.8125 8 3.8125C10.325 3.8125 12.2188 5.70622 12.2188 8.03125C12.2188 10.3562 10.325 12.25 8 12.25ZM13.1563 3.8125C12.6406 3.8125 12.2188 3.39063 12.2188 2.875C12.2188 2.35938 12.6406 1.9375 13.1563 1.9375C13.6719 1.9375 14.0938 2.35938 14.0938 2.875C14.0938 3.39063 13.6719 3.8125 13.1563 3.8125ZM8 4.75C6.19063 4.75 4.71875 6.22188 4.71875 8.03125C4.71875 9.84063 6.19063 11.3125 8 11.3125C9.80938 11.3125 11.2813 9.84063 11.2813 8.03125C11.2813 6.22188 9.80938 4.75 8 4.75ZM8 4.75C6.19063 4.75 4.71875 6.22188 4.71875 8.03125C4.71875 9.84063 6.19063 11.3125 8 11.3125C9.80938 11.3125 11.2813 9.84063 11.2813 8.03125C11.2813 6.22188 9.80938 4.75 8 4.75ZM8 4.75C6.19063 4.75 4.71875 6.22188 4.71875 8.03125C4.71875 9.84063 6.19063 11.3125 8 11.3125C9.80938 11.3125 11.2813 9.84063 11.2813 8.03125C11.2813 6.22188 9.80938 4.75 8 4.75Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e9d3b0cdd2522ddd23312cf5b176bdca.svg";
export { ForwardRef as ReactComponent };